import { has } from 'lodash-es'
import { schemaUpgradeRegistry } from './registry'
import { ComponentSchema, UpgradeRegistryItem } from './upgrader.types'
import { getCompChildren, replaceComponentAssets } from '@haohan/clw-utils'
import { useProject } from '@haohan/clw-store'

const DEFAULT_VERSION = 1

/**
 * 遍历执行页面的组件集合，做统一升级
 */
export function upgradePageSchema(widgetDataList: Widget[]) {
  // --- 静态资源优化-编辑模式 step2: 组件兼容
  // const assetsOpts = useProject().assetsOpts?.data || []
  // assetsOpts.length && replaceComponentAssets(widgetDataList, assetsOpts)
  // ----
  widgetDataList.forEach(async (wdl: any) => {
    if (wdl.type) {
      upgradeComponentSchema(wdl)
    }
    const children = getCompChildren(wdl)
    if (children.length > 0) {
      for (const childObj of children) {
        upgradePageSchema(childObj.list)
      }
    }
  })
}
/**
 * 执行指定from 号的升级逻辑
 * @param schema 当前组件的 schema
 * @param globalUpgrades 通过升级逻辑
 * @param workingVersion 需要执行的版本号
 */
function doGlobalUpgrades(
  schema: ComponentSchema,
  globalUpgrades: UpgradeRegistryItem,
  workingVersion: number
) {
  // 先执行公共升级逻辑，但是不更新版本号
  // 查找公共升级脚本中，与当前 workingVersion 一致的脚本
  const _doGlobalUpgrades = globalUpgrades?.upgrades
    .filter((up) => up.from === workingVersion)
    .sort((a, b) => a.to - b.to)
  for (const _globalUpgrade of _doGlobalUpgrades!) {
    _globalUpgrade.upgrade(schema)
  }
}

/**
 * 按版本号升级组件的 schema
 * @param schema 当前组件的 schema
 * @returns 新的 schema
 */
export function upgradeComponentSchema(schema: ComponentSchema) {
  const currentVersion = has(schema, 'version') ? schema.version : DEFAULT_VERSION
  // 当前工作版本标志
  let workingVersion = currentVersion
  // 执行公共升级逻辑
  const globalUpgrades = schemaUpgradeRegistry.find((r) => r.component === '*')
  doGlobalUpgrades(schema, globalUpgrades!, workingVersion!)
  // 如果执行完公共逻辑后，版本号发生了变化，这里需要进行更新
  if (has(schema, 'version') && schema.version !== workingVersion) {
    workingVersion = schema.version
  }

  // 特点组件升级逻辑
  const registry = schemaUpgradeRegistry.find((r) => r.component === schema.type)

  if (!registry) return schema
  // 对应组件升级逻辑
  const applicableUpgrades = registry.upgrades
    .filter((up) => up.from >= workingVersion)
    .sort((a, b) => a.from - b.from)

  applicableUpgrades.forEach(({ from, to, upgrade }, index) => {
    // 第一次已经在外出执行过，不用再重复执行
    if (index !== 0) {
      doGlobalUpgrades(schema, globalUpgrades!, workingVersion!)
    }
    // 执行组件升级逻辑
    if (workingVersion! <= from) {
      upgrade(schema)
      schema.version = to
      workingVersion = to
    }
  })
}

// /**
//  * 按版本号升级组件的 schema
//  * @param schema 当前组件的 schema
//  * @returns 新的 schema
//  */
// export function upgradeComponentSchema(schema: ComponentSchema): ComponentSchema {
//   const currentVersion = schema.version ?? DEFAULT_VERSION
//   const registry = schemaUpgradeRegistry.find((r) => r.component === schema.type)

//   if (!registry) return schema

//   let newSchema = { ...schema }
//   let workingVersion = currentVersion

//   const applicableUpgrades = registry.upgrades
//     .filter((up) => up.from >= workingVersion)
//     .sort((a, b) => a.from - b.from)

//   for (const { from, to, upgrade } of applicableUpgrades) {
//     if (workingVersion === from) {
//       newSchema = upgrade(newSchema)
//       newSchema.version = to
//       workingVersion = to
//     }
//   }

//   return newSchema
// }
